import { render, staticRenderFns } from "./ImportacaoSucessoTabela.vue?vue&type=template&id=a0e27162&lang=html&"
import script from "./ImportacaoSucessoTabela.vue?vue&type=script&lang=js&"
export * from "./ImportacaoSucessoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/importacao/ImportacaoSucessoTabela.vue
// module id = 1427
// module chunks = 28